import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import { loginReducer, loginReducerInitialState } from '../login/loginReducer';
import {
	preceedingsReducer,
	preceedingReducerInitialState,
} from '../preceeding/preceedingReducer';
import { userReducer, userReducerInitialState } from '../user/userReducer';
import {
	globalReducer,
	globalReducerInitialState,
} from '../global/globalReducer';
import {
	constitutionReducer,
	constitutionReducerInitialState,
} from '../constitution/constitutionReducer';
import {
	censusReducer,
	censusReducerInitialState,
} from '../census/censusReducer';
import {
	participationReducer,
	participationReducerInitialState,
} from '../participation/participationReducer';

import { LOGOUT } from '../login/loginActionTypes';

const createRootReducer = history => {
	const appReducer = combineReducers({
		router: connectRouter(history),
		censusReducer,
		loginReducer,
		constitutionReducer,
		preceedingsReducer,
		userReducer,
		globalReducer,
		participationReducer,
	});

	return (state, action) => {
		if (action.type === LOGOUT) {
			state.loginReducer = loginReducerInitialState;
			state.preceedingsReducer = preceedingReducerInitialState;
			state.userReducer = userReducerInitialState;
			state.globalReducer = globalReducerInitialState;
			state.constitutionReducer = constitutionReducerInitialState;
			state.censusReducer = censusReducerInitialState;
			state.participationReducer = participationReducerInitialState;
		}
		return appReducer(state, action);
	};
};

export default createRootReducer;
